const apiUrl = process.env.REACT_APP_API_URL;

export const CheckUser = async (usuari: string, password: string, page : string) => {

    try {
        const response = await fetch(`${apiUrl}:8071/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'pantalla': page
            },
            body: JSON.stringify({usuari, password})
        });
        if (response.ok) {
            const jsonData = await response.json();
            return jsonData;
        } else {
            alert(await response.text());
            return null;
        }

    } catch (error) {
        console.log('Error al obtener los datos:', error);
        return null;
    }
};
